// Extraído de app-routing.module.ts: auth-guard.service.ts precisava importar essa
// constante de volta do módulo de rotas, que por sua vez importa o próprio guard (pra
// canActivate) — um import circular que só não travava por acaso (nenhum teste
// importava o guard isoladamente). Vivendo aqui, os dois lados importam de uma folha
// sem dependências, sem ciclo.
export const LOGIN_ROUTE = "login";
